export enum TemplateTypesEnum {
  ORGANIZATION="organization",
  APPLICATION="application",
  TENET="tenet"
}
